<template>
  <div
    class="calendar"
    @click.stop
  >
    <label class="label">
      <span class="is-semi-bold font-sm">
        <slot />
      </span>
    </label>
    <v-datepicker
      v-model="range"
      placeholder="Selecione uma data"
      :lang="lang"
      :append-to-body="false"
      :clearable="true"
      :editable="true"
      :range="isRange"
      :disabled="disabled"
      :disabled-date="disabledDate"
      value-type="DD/MM/YYYY"
      title-format="DD/MM/YY"
      time-title-format="DD MMM YYYY"
      format="DD/MM/YYYY"
      range-separator=" até "
      @input="$emit('input', range)"
      @change="$emit('change')"
      @click.stop
    />
  </div>
</template>

<script>
import VDatepicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';

export default {
  name: 'BaseCalendar',
  components: {
    VDatepicker,
  },
  props: {
    value: {
      type: [String, Array],
      default: () => [],
      required: false,
    },
    limitDate: {
      type: Boolean,
      default: true,
      required: false,
    },
    customDisabledDate: {
      type: Function,
      default: null,
      required: false,
    },
    isRange: {
      type: Boolean,
      default: true,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    range: [],
    lang: {
      formatLocale: {
        months: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        monthsShort: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
      },
      days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    },
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.range = value;
      },
    },
  },
  methods: {
    disabledDate(date) {
      if (this.customDisabledDate) return this.customDisabledDate(date);
      if (this.limitDate) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date > today.getTime();
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';

.calendar {
  position: relative;

  .mx-datepicker-range {
    width: 100%;
  }

  .label {
    margin-bottom: 0;

    span {
      font: {
        family: Inter;
        size: 14px;
        weight: 400;
      }
      line-height: 20px;
      color: #666;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  :deep(.mx-input) {
    display: block;
    max-width: 100%;
    height: 2.5rem;
    background-color: white;
    border-color: #dbdbdb;
    border-radius: 4px;
    padding: {
      top: calc(0.5em - 1px);
      left: calc(0.75em - 1px);
      bottom: calc(0.5em - 1px);
      right: calc(0.75em - 1px);
    };

    font-size: 1em;
    color: #363636;

    cursor: pointer;
    outline: none;

    &:disabled {
      background: hsl(0, 0%, 96%);
      color: hsl(0, 0%, 48%);
      cursor: not-allowed;
    }
  }
}
</style>
